// extracted by mini-css-extract-plugin
export default {"backdrop":"BackdropLoader_backdrop__gi-jT"};